import { ReactNode, FC } from "react";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Handle } from "./Handle";
import { ItemContent } from "./ItemContent";
import classNames from "classnames";

import styles from "./styles.module.css";

/** The `ListItemOverlay` component properties. */
interface ListItemOverlayProps {

  /** The item children. */
  readonly children?: ReactNode;
}

/** An individual draggable item within the orderable list. */
export const ItemOverlay: FC<ListItemOverlayProps> = (props) => {
  const { children } = props;

  return (
    <div className={classNames(styles.ItemOverlay)}>
      <Shelf spacing="small">
        <Handle className="active" />
        <ItemContent>
          {children}
        </ItemContent>
      </Shelf>
    </div>
  );
};
